import { Partner } from '@core/models/partner';
import { Product } from '@core/models/product.model';
import { OrderStatus } from '@core/constants/order.constant';
import { ShipmentStatus } from '@core/constants/shipment.constant';

export type OrderLinkedShipment = {
  id: string;
  shipmentReference: string;
  status: ShipmentStatus;
  sender: { id: string; name: string } | null;
  receiver: { id: string; name: string } | null;
  trackingNumber: string | null;
  shipDate: string | null;
  deliveryDate: string | null;
  actualDeliveryDate: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OrderShipmentOption = {
  id: string;
  shipmentReference: string;
  status: ShipmentStatus;
};

export type UpdateOrderPayload = {
  status?: OrderStatus;
};

export type OrderExceptionItem = {
  orderId: string;
  senderRef: string;
  productName: string;
  supplierName: string;
  date: string | null;
  daysCallout: number | null;
};

export type OrderExceptions = {
  paused: OrderExceptionItem[];
  delayed: OrderExceptionItem[];
  cancelled: OrderExceptionItem[];
  atRisk: OrderExceptionItem[];
};

export type Order = {
  id: string;
  sender: Partial<Partner>;
  receiver: Partial<Partner>;
  senderRef: string;
  receiverRef: string;
  status: OrderStatus;
  receiverStatus: string;
  createdAt: string;
  updatedAt: string | null;
  deletedAt: string | null;
  confirmedAt: string | null;
  completedAt: string | null;
  items: Product[];
  shipments: OrderLinkedShipment[];
  linkedShipments?: { id: string; reference: string }[];
  meta?: {
    confirmationTime: number | null;
    leadTime: number | null;
    onTime: boolean;
    inFull: boolean;
    otif: boolean | null;
  };
};

export type OrderFilters = {
  size?: number;
  page?: number;
  term?: string;
  status?: OrderStatus[];
  sender?: string | null;
  receiver?: string | null;
  sort?: string | null;
  direction?: string;
  startDate?: string | null;
  endDate?: string | null;
  dateType?: string;
};

export type ProductItem = {
  id: string;
  description: string;
  requesterSku: string;
  supplierSku: string;
  requestedQuantity: number;
  requestedDeliveryDate: string;
};

export type CreateOrderRequest = {
  receiverId: string;
  products: ProductItem[];
  senderRef: string;
  comment: string;
};

export type OrderForSelect = {
  id: string;
  senderRef: string;
  receiverRef?: string | null;
};

export interface OrderStatusItem {
  name: string;
  id: string;
}
